import { render, staticRenderFns } from "./Booking_BlockList_Form.vue?vue&type=template&id=e2d0b7f8&scoped=true&"
import script from "./Booking_BlockList_Form.vue?vue&type=script&lang=js&"
export * from "./Booking_BlockList_Form.vue?vue&type=script&lang=js&"
import style0 from "./Booking_BlockList_Form.vue?vue&type=style&index=0&id=e2d0b7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d0b7f8",
  null
  
)

export default component.exports